module.exports = __webpack_public_path__ + "static/img/101840.b989169c.png";